import MenuDropdown from "./MenuDropdown";
import FooterDropdown from "./FooterDropdown";
import MobileMenu from "./MobileMenu";

new MenuDropdown();
new FooterDropdown();
new MobileMenu();
